<template>
  <div>
    <ca-row>
      <ca-col>
        <ca-button @click="onEdit">Editar</ca-button>
        <ca-button
          class="ca-u-margin-left"
          @click="onDelete">
          Remover
        </ca-button>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="2">
      <ca-col>
        <ca-page>
          <ca-async-content-wrapper
            :key="wrapperKey"
            :on-fetch="getResponsible"
            :on-fetch-success="setResponsible">
            <div v-if="responsible">
              <ca-row>
                <ca-col size="4">
                  <ca-field label="Nome">
                    {{ responsible.name }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Tipo de inscrição">
                    {{ responsible.registerType.description }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Inscrição">
                    {{ responsible.register }}
                  </ca-field>
                </ca-col>
              </ca-row>

              <ca-row>
                <ca-col size="4">
                  <ca-field label="Telefone">
                    {{ responsible.phone }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Rua">
                    {{ responsible.street }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Bairro">
                    {{ responsible.neighborhood }}
                  </ca-field>
                </ca-col>
              </ca-row>

              <ca-row>
                <ca-col size="4">
                  <ca-field label="Número">
                    {{ responsible.number }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Cidade">
                    {{ responsible.city }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Estado">
                    {{ responsible.state.description }}
                  </ca-field>
                </ca-col>
              </ca-row>

              <ca-row>
                <ca-col size="4">
                  <ca-field label="CEP">
                    {{ responsible.zipCode }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Compartilhado">
                    {{ responsible.shared ? 'Sim' : 'Não' }}
                  </ca-field>
                </ca-col>
              </ca-row>
            </div>
          </ca-async-content-wrapper>
        </ca-page>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
import { getErrorMessageFromResponse } from 'packages/common';
import { getResponsible, deleteResponsible } from './responsibleService';
import ResponsibleFormRollover from './ResponsibleFormRollover.vue';

export default {
  name: 'ResponsibleViewPage',
  data() {
    return {
      wrapperKey: 0,
      responsible: null,
      responsibleId: this.$route.params.id,
    };
  },
  methods: {
    getResponsible() {
      return getResponsible(this.responsibleId);
    },
    setResponsible(responsible) {
      this.responsible = responsible;
    },
    onEdit() {
      this.$dialogModal(ResponsibleFormRollover, {
        props: {
          responsibleId: this.responsibleId,
        },
        on: {
          completed: () => this.updateWrapper(),
        },
      }).open();
    },
    onDelete() {
      this.$caConfirm({
        title: 'Confirmação de exclusão',
        message: 'Deseja realmente excluir este responsável?',
        onConfirm: async () => {
          try {
            await deleteResponsible(this.responsibleId);
            this.$toaster.success('Responsável excluído com sucesso!');
            this.$router.push({ name: 'ResponsiblePage' });
          } catch (error) {
            this.$toaster.error(getErrorMessageFromResponse(error));
          }
        },
      });
    },
    updateWrapper() {
      this.wrapperKey++;
    },
  },
};
</script>
